import instance from "../../index";
import {PagedList} from "../../../models/paged-list";
import {ShortDto} from "../../../models/short-dto";
import {BaseResponse} from "../../../models/base-response";
import {BonusConfig} from "../../../models/bonusConfig";
import {BonusConfigsFilter} from "../../../filters/bonus-configs-filter";
import {CreateBonusConfigRequest} from "../../../models/requests/create-bonus-config-request";
import {EditBonusConfigRequest} from "../../../models/requests/edit-bonus-config-request";
import {CreateEngineLoadExceptionRequest} from "../../../models/requests/create-engine-load-exception-request";

export const useBonusConfigService = () => {
    async function activateBonusConfig(id: string): Promise<BonusConfig> {
        const response = await instance.put<BonusConfig>(`/v1/backoffice/bonus-configs/${id}/active`);
        return response.data;
    }

    async function inactivateBonusConfig(id: string): Promise<BonusConfig> {
        const response = await instance.put<BonusConfig>(`/v1/backoffice/bonus-configs/${id}/deactive`);
        return response.data;
    }

    async function deleteBonusConfig(id: string) {
        return await instance.delete(`/v1/backoffice/bonus-configs/${id}`);
    }

    async function getBonusConfigById(id: string): Promise<BonusConfig> {
        const response = await instance.get<BaseResponse<BonusConfig>>(`/v1/backoffice/bonus-configs/${id}`);
        return response?.data?.data;
    }

    async function getBonusConfigs(filter?: BonusConfigsFilter): Promise<PagedList<BonusConfig>> {
        const response = (await instance.get<BaseResponse<PagedList<BonusConfig>>>('/v1/backoffice/bonus-configs', {
            params: filter
        }));
        return response.data.data;
    }

    async function getAllBonusConfigShortDto(filter?: BonusConfigsFilter): Promise<ShortDto[]> {
        const response = await instance.get<ShortDto[]>('/v1/backoffice/bonus-configs/all', {
            params: filter
        });
        return response.data;
    }

    async function createEngineLoadBonusConfig(request: Partial<CreateBonusConfigRequest>): Promise<BonusConfig> {
        const response = await instance.post<BonusConfig>(`/v1/backoffice/bonus-configs/engine-load`, request);
        return response?.data;
    }

    async function createEngineLoadExceptionBonusConfig(request: Partial<CreateEngineLoadExceptionRequest>): Promise<BonusConfig> {
        const response = await instance.post<BonusConfig>(`/v1/backoffice/bonus-configs/engine-load-exception`, request);
        return response?.data;
    }

    async function createInertiaBonusConfig(request: Partial<CreateBonusConfigRequest>): Promise<BonusConfig> {
        const response = await instance.post<BonusConfig>(`/v1/backoffice/bonus-configs/inertia`, request);
        return response?.data;
    }

    async function editBonusConfig(request: Partial<EditBonusConfigRequest>, id: string | string[] | undefined): Promise<BonusConfig> {
        const response = await instance.put<BonusConfig>(`/v1/backoffice/bonus-configs/${id}`, request);
        return response?.data;
    }

    return {
        activateBonusConfig,
        inactivateBonusConfig,
        deleteBonusConfig,
        getBonusConfigById,
        getBonusConfigs,
        getAllBonusConfigShortDto,
        createEngineLoadExceptionBonusConfig,
        createEngineLoadBonusConfig,
        createInertiaBonusConfig,
        editBonusConfig
    }
}
export default useBonusConfigService;